import { startApp } from '@horof/shared';
import { App } from './App';
import './committee.css';

startApp({ allow: ['committee'], App });
